<template>
  <div class="dev-main ">
    <el-card class="box-card clearfix">

      <el-form ref="form" :model="form" label-width="0px" :rules="rules">
        <div class="vertical fl">
          <i class="el-icon-edit pvt-color" style="font-size: 24px;"></i>
          <span>写文章</span>
        </div>
        <el-form-item label="" class="clearfix" prop="title">
          <p class="fl">标题</p>
          <el-input v-model="form.title"></el-input>
        </el-form-item>


        <el-form-item label="" prop="content" class="clearfix">
          <p class="fl">内容</p>
          <div class="clearfix">
           <!-- <tinymce-editor
              id="editor"
              ref="editor"
              v-model="form.content"
              :height="realHeight"
              @handleImgUpload="imgUpload"
            />-->
            <Vditor v-model="form.content" editorId="vditor" />
          </div>
        </el-form-item>
        <el-form-item label="" prop="subCategoryId">
          <div class="clearfix">
            <p class="fl">标签</p>
          </div>

          <div class="vertical fl">
            <el-tag v-if="activeSubCategory.subCategoryName != null" type="warning">
              {{activeSubCategory.subCategoryName}}
            </el-tag>
            <i class="el-icon-plus pvt-color" style="font-size: 22px;" @click="openDialog"></i>
            <span>至少添加一个标签</span>
          </div>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="" class="fl">
         <!-- <el-checkbox v-model="anonymousFlag">匿名</el-checkbox>-->
          <el-button type="primary" @click="submitTopic('save')" class="main-bg-color" size="tiny" >
            保存
          </el-button>
          <el-button type="primary" @click="submitTopic('submit')" class="main-bg-color" size="tiny" >
            发布文章
          </el-button>
        </el-form-item>
      </el-form>

    </el-card>
    <el-dialog
      title="选择标签"
      :visible.sync="dialogVisible"
      width="50%">
      <el-radio-group v-model="form.subCategoryId">
        <el-radio v-for="o in subCategoryList" @change="setActiveSubCategory(o)" :label="o.subCategoryId"
                  :key="o.subCategoryId">{{o.subCategoryName}}
        </el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
  import TinymceEditor from '@/components/editor/tinymce-editor'
  import {Message} from "element-ui";
  import Vditor from '@/components/editor/vditor'
  export default {
    components: {TinymceEditor, Vditor},
    data() {
      return {
        form: {
          title: '',
          content: '', //富文本的内容
          categoryId: 3,
          subCategoryId: ''
        },
        activeSubCategory: {},
        anonymousFlag: false,
        dialogVisible: false,
        subCategoryList: [],
        rules: {
          title: [{required: true, message: '请输入标题', trigger: 'blur'}],
          content: [{required: true, message: '请输入内容', trigger: 'blur'}],
          subCategoryId: [{required: true, message: '请选择标签', trigger: 'change'}],
        },
        baseUrl: window.baseUrl, //默认为'' 空字符串
      }
    },
    computed: {
      realHeight() {
        return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 200
      }
    },
    created() {

    },
    methods: {
      async imgUpload(blobInfo, success, failure) {
        const formData = new FormData();
        formData.append('file', blobInfo.blob());
        try {
          this.postMultipartRequest('/util/upload/picFile', formData).then(resp => {
            if (resp && resp.status == 200) {
              var url = resp.data.result.url;
              success(url);

            }
          })

        } catch (e) {
          console.log(e);
          failure('上传失败:' + e);
        }
      },
      submitTopic: function (submitType) {
        var _this = this;
        var params = {};
        params.title = _this.form.title;
        params.content = _this.form.content;
        params.categoryId = _this.form.categoryId
        params.subCategoryId = _this.form.subCategoryId
        params.anonymousFlag = _this.anonymousFlag
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/tccTopic/addTopic?anonymousFlag=' + _this.anonymousFlag, JSON.stringify(params)).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  Message.success(data.message);
                  if(submitType == 'submit'){
                  _this.form = {};}
                } else {
                  Message.error(data.message);
                  _this.change();
                }

              }
            });
          }
        })
      },
      getSubCategories: function () {
        this.getRequest('/tccTopic/getSubCategoryList', {'categoryId': '3'}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.subCategoryList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      openDialog: function () {
        this.dialogVisible = true;
      },
      setActiveSubCategory: function (o) {
        this.activeSubCategory = o;
        console.log(this.activeSubCategory)
      }
    },
    mounted: function () {
      this.getSubCategories();
      this.$emit('setActiveIndex', "6")
    },
    beforeDestroy() {

    }
  }
</script>

